import React from 'react';
import styles from './Card.module.scss';

interface CardProps {
  children: React.ReactNode;
  className?: string | undefined;
  onClick?: (() => void) | undefined;
}

interface CardHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

interface CardStatProps {
  label: string;
  value: string | number;
  change?: {
    value: string;
    trend: 'up' | 'down';
  };
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({ children, className, onClick }) => {
  const cardClasses = `${styles.card} ${onClick ? styles.clickable : ''} ${className || ''}`;
  
  return (
    <div className={cardClasses} onClick={onClick}>
      {children}
    </div>
  );
};

export const CardHeader: React.FC<CardHeaderProps> = ({ title, subtitle, action }) => {
  return (
    <div className={styles.cardHeader}>
      <div>
        <h3 className={styles.cardTitle}>{title}</h3>
        {subtitle && <p className={styles.cardSubtitle}>{subtitle}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
};

export const CardBody: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className={styles.cardBody}>{children}</div>;
};

export const CardFooter: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className={styles.cardFooter}>{children}</div>;
};

export const StatCard: React.FC<CardStatProps> = ({ label, value, change, onClick }) => {
  const cardClasses = `${styles.statCard} ${onClick ? styles.clickable : ''}`;
  
  return (
    <div className={cardClasses} onClick={onClick}>
      <div className={styles.statLabel}>{label}</div>
      <div className={styles.statValue}>{value.toLocaleString()}</div>
      {change && (
        <div className={`${styles.statChange} ${change.trend === 'up' ? styles.positive : styles.negative}`}>
          <span>{change.trend === 'up' ? '↑' : '↓'}</span>
          <span>{change.value}</span>
        </div>
      )}
    </div>
  );
};

